module.exports = __webpack_public_path__ + "media/images/lb/493-eb990816f2c3eadf253f07e8abc82582.svg";